var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 11.0103C15.9997 11.1103 15.8993 11.3101 15.7991 11.4098L6.88094 20.2916C6.68053 20.4912 6.28053 20.4904 6.08094 20.29C5.88135 20.0896 5.88217 19.6896 6.08257 19.49L14.5999 11.0074L6.11732 2.49004C5.91773 2.28963 5.91855 1.88963 6.11895 1.69004C6.31936 1.49045 6.71936 1.49127 6.91895 1.69168L15.8007 10.6098C15.9005 10.7101 16.0001 10.9103 15.9999 11.0103Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.795fb5c440c932fa9d13c3c1e5583337.svg";
export { ForwardRef as ReactComponent };